import React from "react";

export function GameChrome({
  gameKey,
  label,
  emoji,
  color,
  difficulty,
  onBack,
  onNextGame,
  nextGameLabel,
  completedGames,
  children,
}: {
  gameKey: string;
  label: string;
  emoji: string;
  color: string;
  difficulty?: string;
  onBack: () => void;
  onNextGame?: () => void;
  nextGameLabel?: string;
  completedGames: Set<string>;
  children: React.ReactNode;
}) {
  return (
    <div className="pt-[52px]">
      {children}
    </div>
  );
}
